import Splitting from "splitting";
import {gsap} from "gsap";
import {
    CharByLine,
    getElementAnimateDelay,
    inViewPointerMobile,
    setElementAnimateOffsetResponsive,
    wordByWord
} from "../../../libs/helper";
import AnimationHelper from "../../../libs/animation-helper";

class AnimationLines {
    constructor(el, options) {
        this.DOM = {el};
        if (!inViewPointerMobile(this.DOM.el) && options.handleScrolling) return;
        this.DOM.el.classList.add('animation--lines');
        this.options = {...options};
        this.addAnimationType();
    }

    addAnimationType() {


        this.descSplitting = Splitting({
            target: this.DOM.el,
            by: 'lines'
        });
        let optionsSwitch;
        switch (this.options.type) {
            case "mask_bottom":
                wordByWord(this.descSplitting[0].lines);
                optionsSwitch = {
                    _from: {y: '100%'},
                    _to: {
                        y: '0%',
                        ease: 'power3.out',
                        duration: .8,
                        delay: 0
                    },
                    _out: {
                        y: '100%',
                        ease: 'power3.out',
                        duration: .8,
                        delay: 0
                    }
                };
                this.DOM.el.classList.add('lines_mask--bottom');
                break;

            case "lines--chars":
                CharByLine(this.descSplitting[0].lines);

                optionsSwitch = {
                    _from: {y: '135%', rotationX: 20},
                    _to: {
                        y: '0%',
                        rotationX: 0,
                        duration: 1.2,
                        stagger: .015,
                        delay: 0,
                        ease: 'power3.out'
                    },
                    _out: {
                        y: '-100%',
                        rotationX: 0,
                        duration: .8,
                        stagger: .01,
                        ease: 'power3.inOut'
                    }
                };

                this.DOM.el.classList.add('animation--chars--3d');

                break;
            default:
                optionsSwitch = {
                    _from: {y: '120%', opacity: 0},
                    _to: {
                        y: '0%',
                        opacity: 1,
                        ease: 'power3.out',
                        duration: .8,
                        delay: 0
                    }
                };
                break;
        }

        this.options._from = Object.assign({}, optionsSwitch._from, this.options._from);
        this.options._to = Object.assign({}, optionsSwitch._to, this.options._to);
        this.options._out = Object.assign({}, optionsSwitch._out, this.options._out);

        this.DOM.el.classList.remove('is-animation');
        gsap.set(this.descSplitting[0].lines, this.options._from);

        if (this.options.handleScrolling) {
            this.animationHelper = new AnimationHelper({
                el: this.DOM.el,
                animationIn: this.animationIn.bind(this),
                options: this.options
            });
        }
    }

    resetAnimation() {
        this.animationHelper && this.animationHelper.addObServer();
        gsap.killTweensOf(this.descSplitting[0].lines);
        gsap.set(this.descSplitting[0].lines, this.options._from);
    }

    animationIn(delay = 0) {
        if (this.animationHelper) {
            delay += this.animationHelper.getDelayAnimation();
            this.animationHelper.removeHandleScrolling();
        }

        const optionTo = Object.assign({delay: 0}, this.options._to);
        optionTo.delay += delay;

        this.descSplitting[0].lines.forEach(line => {
            gsap.killTweensOf(line);
            gsap.fromTo(line, this.options._from, optionTo);
            if (this.options.type === 'lines--chars') {
                optionTo.delay += .035;
            } else {
                optionTo.delay += .085;
            }
        });
    }

    animationOnlyIn(delay = 0) {
        const optionTo = Object.assign({delay: 0}, this.options._to);
        optionTo.delay += delay;
        this.descSplitting[0].lines.forEach(line => {
            gsap.killTweensOf(line);
            gsap.to(line, optionTo);
        });
    }

    animationOut(delay) {
        this.descSplitting[0].lines.forEach(line => {
            gsap.killTweensOf(line);
            gsap.to(line, {...this.options._out, ...{delay}});
        });
    }

    clearAnimation() {
        this.descSplitting[0].lines.forEach(line => {
            line.forEach(char => {
                char.style = {};
            });
        });
    }
}

export default AnimationLines;